import React from "react";
import Icone from "./util/Icone";
import { faArrowRight } from "./util/icones";
import { servicos } from "./data/servicos";

export const Destaque = ({ texto, destaque }) => {
  const [antes, depois] = texto.split(destaque);
  return (
    <>
      {antes || null}
      <strong className="text-gradient">{destaque}</strong>
      {depois || null}
    </>
  );
};

const colunas = (quantidade) => (quantidade === 3 ? "xl:grid-cols-3" : "xl:grid-cols-4");

export const Itens = ({ secao, claro }) => (
  <ul className={`grid grid-cols-1 md:grid-cols-2 ${colunas(secao.itens.length)} gap-10 xl:gap-8`}>
    {secao.itens.map((item, indice) => (
      <li key={item.titulo} className={`border-t-2 pt-6 ${claro ? "border-white/30" : "border-pattern"}`}>
        {secao.numerada ? <p className={`font-display text-4xl font-bold mb-4 ${claro ? "text-secondary" : "text-pattern"}`}>{`0${indice + 1}`}</p> : null}
        <h3 className="text-xl xl:text-2xl font-semibold mb-3">{item.titulo}</h3>
        <p className={`text-lg leading-relaxed ${claro ? "text-white/80" : "text-gray-700"}`}>{item.texto}</p>
      </li>
    ))}
  </ul>
);

export const LinkSeta = ({ href, children }) => (
  <a href={href} className="inline-flex items-center gap-2 font-semibold text-pattern-dark hover:underline mt-6">
    {children}
    <Icone icon={faArrowRight} className="text-sm" />
  </a>
);

export const OutrosServicos = ({ atual }) => {
  const lista = Object.values(servicos).filter((outro) => outro.slug !== atual);
  return (
    <ul className={`grid grid-cols-1 md:grid-cols-2 ${lista.length === 3 ? "xl:grid-cols-3" : ""} gap-10 xl:gap-16`}>
      {lista.map((outro) => (
        <li key={outro.slug} className="border-t-2 border-pattern pt-6">
          <p className="text-sm font-semibold uppercase tracking-widest text-pattern-dark mb-4">{outro.rotulo}</p>
          <h3 className="text-2xl xl:text-3xl font-semibold leading-tight mb-4">{outro.chamada}</h3>
          <p className="text-lg leading-relaxed text-gray-700">{outro.resumo}</p>
          <LinkSeta href={outro.slug}>{outro.linkTexto}</LinkSeta>
        </li>
      ))}
    </ul>
  );
};

export const fundosDosBlocos = (blocos) => {
  const fundos = [];
  let ultimoClaro = "gray";
  blocos.forEach((bloco) => {
    if (bloco.azul) {
      fundos.push("blue");
      return;
    }
    ultimoClaro = ultimoClaro === "white" ? "gray" : "white";
    fundos.push(ultimoClaro);
  });
  return fundos;
};
